import styled, { css } from 'styled-components'

import { mediaMaxMobile, Skeleton } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

export const UserProfilePnlSkeleton: React.FC<ClassNameProps> = ({
  className,
}) => (
  <Root className={className}>
    <Outline>
      <Summary>
        {Array.from({ length: 4 }).map((_, index) => (
          <SummaryCol key={index}>
            <Skeleton width={72} height={12} />
            <Skeleton width={48} height={20} />
          </SummaryCol>
        ))}
      </Summary>
      <ChartArea>
        <ViewToggle>
          <Skeleton width={120} height={12} />
        </ViewToggle>
        <Chart>
          <Skeleton.Surface />
        </Chart>
      </ChartArea>
    </Outline>
  </Root>
)

const Root = styled.div`
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: grid;
  min-height: 0;
  background: var(--backgroundA-2);
`

const Outline = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  min-height: 0;
`

const Summary = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 10px;
  padding-inline: 16px;
  padding-top: 20px;
  align-items: start;

  ${mediaMaxMobile(css`
    grid-template-columns: repeat(2, auto);
    gap: 14px;
    padding-inline: 14px;
  `)}
`

const SummaryCol = styled.div`
  display: grid;
  gap: 10px;
  justify-items: start;

  ${mediaMaxMobile(css`
    gap: 4px;
  `)}
`

const ChartArea = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 20px;
  height: 100%;
  min-height: 0;
  padding-block-end: 16px;
`

const ViewToggle = styled.div`
  display: grid;
  justify-content: start;
  margin-top: 16px;
  margin-bottom: 4px;
  padding-inline: 16px;
`

const Chart = styled.div`
  position: relative;
  height: 100%;
  min-height: 0;
  padding-inline: 7px;
`
